<template>
    <div
        class="af-modal afu-fixed afu-w-full afu-h-full afu-top-0 afu-left-0 afu-flex afu-justify-center afu-overflow-auto afu-bg-modal afu-z-1000"
        :class="getModalClass"
        @click.self="handleClose"
    >
        <div
            class="af-modal-container afu-w-full afu-bg-white afu-z-100 afu-overflow-auto afu-rounded-card afu-shadow-lg"
            :class="getModalContainerClass"
        >
            <div
                v-if="variant == 'default'"
                class="af-modal-content afu-text-left"
                :class="getModalContentClass"
            >
                <!--Title-->
                <slot name="header" />
                <!--Body-->
                <slot name="body" />
                <!--Footer-->
                <slot name="footer" />
            </div>
            <div
                v-if="variant == 'var2'"
                class="af-modal-content center"
                :class="getModalContentClass"
            >
                <!--Title-->
                <div class="afu-px-6 afu-py-5 afu-flex afu-justify-between afu-text-black afu-text-lg afu-font-semibold afu-border afu-border-solid afu-border-l-0 afu-border-r-0 afu-border-t-0 afu-border-b afu-border-neutral">
                    <slot name="headerTitle" />
                    <svg 
                        width="16" 
                        height="17" 
                        viewBox="0 0 16 17" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        class="afu-cursor-pointer"
                        @click="handleClose()"
                    >
                        <path 
                            d="M9.6973 8.21183L14.8255 2.94805L15.883 1.86254C16.039 1.70241 16.039 1.4422 15.883 1.28207L14.7515 0.120611C14.5955 -0.0395193 14.3419 -0.0395193 14.1859 0.120611L8.00025 6.46989L1.81456 0.120098C1.65855 -0.0400326 1.40504 -0.0400326 1.24904 0.120098L0.117004 1.28156C-0.0390012 1.44169 -0.0390012 1.7019 0.117004 1.86203L6.3032 8.21183L0.117004 14.5611C-0.0390012 14.7212 -0.0390012 14.9814 0.117004 15.1416L1.24854 16.303C1.40454 16.4632 1.65805 16.4632 1.81406 16.303L8.00025 9.95376L13.1284 15.2175L14.1859 16.303C14.3419 16.4632 14.5955 16.4632 14.7515 16.303L15.883 15.1416C16.039 14.9814 16.039 14.7212 15.883 14.5611L9.6973 8.21183Z" 
                            fill="#AEAEAA"
                        />
                    </svg>
                </div>
                <!--Body-->
                <div class="afu-p-7 afu-text-center afu-text-xl afu-font-semibold afu-text-black">
                    <slot name="bodyText" />
                </div>
                <!--Footer-->
                <div
                    v-if="!noFooter"
                    class="afu-px-7 afu-pb-7 afu-flex afu-items-center afu-justify-center afu-gap-2"
                >
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'C1Modal',

        props: {
            modalClass: {
                type: String,
                default: '',
            },

            modalContainerClass: {
                type: String,
                default: '',
            },

            modalContentClass: {
                type: String,
                default: 'afu-p-6',
            },

            position: {
                type: String,
                default: 'center',
            },

            size: {
                type: String,
                default: 'sm',
            },

            variant: {
                type: String,
                default: 'default',
            },
            noFooter: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {};
        },

        computed: {

            getModalClass() {
                let positionClass = `afu-items-${this.position}`;
                if (this.size === 'full') {
                    positionClass = `${positionClass}`;
                } else {
                    positionClass = `${positionClass} afu-h-full`;
                }
                return [
                    this.modalClass,
                    positionClass,
                ];
            },

            getModalContainerClass() {
                let sizeClass = '';
                if (this.size === 'full') {
                    sizeClass = `${sizeClass} afu-h-full afu-m-0 afu-max-h-100p`;
                } else {
                    sizeClass = `${sizeClass} afu-rounded-card afu-max-h-80p`;
                }
                if(this.variant == 'var2') {
                    sizeClass = `${sizeClass} afu-max-w-modal`;
                }
                else {
                    sizeClass = `${sizeClass} afu-max-w-${this.size}`;
                }

                return [
                    this.modalContainerClass,
                    sizeClass,
                ];
            },

            getModalContentClass() {
                return [
                    this.modalContentClass,
                ];
            },
        },

        mounted() {
            this.$emit('show');
            window.addEventListener('keydown', this.handleKeyPress);
            window.document.body.style.overflow = 'hidden';
        },

        destroyed() {
            window.removeEventListener('keydown', this.handleKeyPress);
            window.document.body.style.overflow = 'auto';
        },

        methods: {
            handleKeyPress(e) {
                if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
                    this.$emit('close');
                }
            },

            handleClose() {
                this.$emit('close');
            },
        },
    };
</script>
